module.exports = __webpack_public_path__ + "img/icon_addressBook_Gray.c50bb502.svg";